import { render, staticRenderFns } from "./ModalLiveVideo.vue?vue&type=template&id=dfcfe400&scoped=true&"
import script from "./ModalLiveVideo.vue?vue&type=script&lang=js&"
export * from "./ModalLiveVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModalLiveVideo.vue?vue&type=style&index=0&id=dfcfe400&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcfe400",
  null
  
)

export default component.exports